import { Dialog } from "@mui/material";
import React from "react";
import { Document, Page, pdfjs } from "react-pdf";
import Helpers from "../../helpers/helpers";
import CustomButton from "../Form/CustomButton";
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

const AppAttachmentDialog = ({
    open, close, fullWidth = false, file, filetype, width = '70%', filename = ''
}) => {
    const [numPages, setNumPages] = React.useState(null);
    const [pagesRendered, setPagesRendered] = React.useState(0);
    const [currentPage, setCurrentPage] = React.useState(1);
    const styles = {
        page: {
            flexDirection: "row",
            backgroundColor: "#fff",
            width: "100",
            orientation: "portrait",
        },
        view: {
            width: "100%",
            height: "100%",
            padding: 0,
            backgroundColor: "white",
        },
        image: {
            objectFit: "cover",
        }
    };

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
        setPagesRendered(1);
    }

    const onRenderSuccess = () => {
        setPagesRendered(pagesRendered + 1)
    }

    const handleScroll = (e) => {
        let totalHeight = e.target.scrollHeight;
        let currentHeight = e.target.scrollHeight - e.target.scrollTop;
        let heightPerPage = e.target.scrollHeight / numPages;
        let currentPage = (totalHeight - currentHeight) / heightPerPage;
        currentPage = (currentPage + 1).toFixed(0) > numPages ? (currentPage).toFixed(0) : (currentPage + 1).toFixed(0);
        setCurrentPage(currentPage);
    }

    const pagesRenderedPlusOne = Math.min(pagesRendered + 1, numPages);

    const getWidthInNum = () => {
        let cleanWidth = width.replace('%', '');
        cleanWidth = parseInt(cleanWidth);
        return (window.innerWidth * ((cleanWidth / 100) - 0.01));
    }

    const handleDownload = () => {
        Helpers.handleDownloadDocument(file, `${filename ? filename : 'attachment'}`, filename ? true : false);
    }

    return (
        <React.Fragment>
            <Dialog
                open={open}
                fullWidth={fullWidth}
                PaperProps={{
                    sx: {
                        width: { xs: "100%", sm: width || '70%' },
                        borderRadius: "5px",
                        maxWidth: { xs: "100%", sm: width || '70%' },
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        maxHeight: '90vh',
                    }
                }}
                onClose={(e) => close()}
            >
                <div className="" style={{ position: 'absolute', top: 20, right: 25, zIndex: 5 }}>
                    <CustomButton
                        title={<>Download</>}
                        press={() => { handleDownload() }}
                        textColor={"white"}
                        backgroundColor={"#434343"}
                        padding={20}
                        paddingInline={10}
                        borderStyle={"0px"}
                    />
                </div>
                <div className="d-flex justify-content-center" style={{ overflowY: 'auto' }}>

                    {
                        filetype === 'pdf' || filetype === 'application/pdf' ?
                            <>
                                <div onScroll={(e) => handleScroll(e)} style={{ backgroundColor: 'white' }}>
                                    <Document
                                        file={file}
                                        onLoadSuccess={onDocumentLoadSuccess}
                                    >
                                        {Array.from(new Array(pagesRenderedPlusOne), (el, index) => {
                                            const isCurrentlyRendering = pagesRenderedPlusOne === index + 1;
                                            const isLastPage = numPages === index + 1;
                                            const needsCallbackToRenderNextPage = isCurrentlyRendering && !isLastPage;
                                            return (
                                                <Page
                                                    renderMode="canvas"
                                                    renderTextLayer={false}
                                                    renderAnnotationLayer={false}
                                                    customTextRenderer={false}
                                                    width={getWidthInNum()}
                                                    margin="0px"
                                                    key={`page_${index + 1}`}
                                                    pageNumber={index + 1}
                                                    style={styles.page}
                                                    size="A4"
                                                    onRenderSuccess={
                                                        needsCallbackToRenderNextPage ? onRenderSuccess : null
                                                    }
                                                >
                                                    <hr></hr>
                                                </Page>
                                            )

                                        })}
                                    </Document>
                                </div>
                            </>
                            : filetype === "mp4" || filetype === "video/mp4" ?
                                <video width={'100%'} height={window.innerHeight * 0.8} style={{ borderRadius: "10px", backgroundColor: "black" }} controls>
                                    <source src={file} type="video/mp4" />
                                </video>
                                : <img src={file || Helpers.noImage} alt="attachment" width={'100%'} height={window.innerHeight * 0.9} style={{ objectFit: 'contain', backgroundColor: "whitesmoke" }} />
                    }
                </div>
            </Dialog>
        </React.Fragment>
    );
};

export default AppAttachmentDialog;
